/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';
import { globalMessages } from 'src/core/utils/globalMessages';

export const entityMigrationModalMessages = defineMessages({
    initialScreenTitle: {
        id: 'entityMigration.initialScreenTitle',
        defaultMessage: 'What happens when you upgrade'
    },
    compositeEntitiesScreenTitle: {
        id: 'entityMigration.compositeEntitiesScreenTitle',
        defaultMessage: 'Select your composite entities'
    },
    trainingScreenTitle: {
        id: 'entityMigration.trainingScreenTitle',
        defaultMessage: 'You have untrained changes'
    },
    continueText: {
        id: 'entityMigration.continueText',
        defaultMessage: 'Continue'
    },
    upgraded: {
        id: 'entityMigration.upgraded',
        defaultMessage: 'upgraded'
    },
    successfulDoneScreenTitle: {
        id: 'entityMigration.successfulDoneScreenTitle',
        defaultMessage: 'You’re done!'
    },
    trainingFailedDoneScreenTitle: {
        id: 'entityMigration.trainingFailedDoneScreenTitle',
        defaultMessage: 'Your composites were successfully upgraded'
    },
    migrationFailedDoneScreenTitle: {
        id: 'entityMigration.migrationFailedDoneScreenTitle',
        defaultMessage: 'Upgrade has failed'
    },
    tryEntitiesButton: {
        id: 'entityMigration.tryEntitiesButton',
        defaultMessage: 'Try your new entities'
    },
    closeText: {
        id: 'entityMigration.closeText',
        defaultMessage: 'Close'
    }
});

/**
 * Returns the suitable text combination for active screen.
 */
export const getScreenText = (screenId: number, isTrainingFailed: boolean, isMigrationFailed: boolean) => {
    switch (screenId) {
        case 0:
            return {
                title: entityMigrationModalMessages.initialScreenTitle,
                cancelButtonText: globalMessages.cancel,
                submitButtonText: entityMigrationModalMessages.continueText
            };
        case 1:
            return {
                title: entityMigrationModalMessages.compositeEntitiesScreenTitle,
                cancelButtonText: globalMessages.cancel,
                submitButtonText: entityMigrationModalMessages.continueText
            };
        case 2:
            return {
                title: entityMigrationModalMessages.trainingScreenTitle,
                cancelButtonText: globalMessages.cancel,
                submitButtonText: entityMigrationModalMessages.continueText
            };
        case 3:
            return {
                title: null,
                cancelButtonText: globalMessages.cancel,
                submitButtonText: entityMigrationModalMessages.continueText
            };
        case 4:
        default: {
            let title = entityMigrationModalMessages.successfulDoneScreenTitle;

            if (isTrainingFailed) {
                title = entityMigrationModalMessages.trainingFailedDoneScreenTitle;
            }

            if (isMigrationFailed) {
                title = entityMigrationModalMessages.migrationFailedDoneScreenTitle;
            }

            return {
                title,
                cancelButtonText: entityMigrationModalMessages.closeText,
                submitButtonText: entityMigrationModalMessages.tryEntitiesButton
            };
        }
    }
};
